import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import PortfolioItem from './PortfolioItem';
import { useAppSelector } from '../../store/reducers/store';
import { useParams } from 'react-router-dom';
import { PortfolioLibraryItem } from '../../models/Portfolio';

export interface IPortfolioListProp{
    isAddToExisting?: boolean;
    portfolios: PortfolioLibraryItem[] | undefined;
}

const PortfolioList: React.FC<IPortfolioListProp> = ({ isAddToExisting, portfolios }) => {
    const page = useAppSelector(state => state.portfolioLibrary.page);

    if (portfolios === undefined){
        return <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100px"}>
            <CircularProgress />
        </Box>;
    }
    return <Box display={"flex"} gap={"30px"} justifyContent={"stretch"} width={"100%"} marginTop={"26px"}>
        {portfolios.slice(page*3, page*3+3).map((portfolio) => <PortfolioItem portfolio={portfolio} key={`portfolio-${portfolio.id}`} isAddToExisting={isAddToExisting} />)}
        {portfolios.length === 0 && <Box display={"flex"}><Typography>No portfolio to show</Typography></Box>}
    </Box>
}

export default PortfolioList;